#import "../fragments/inbound-email-rules-fragment.graphql"

mutation UpdateInboundEmailRules($input: InboundEmailRulesUpdateInput!) {
    inboundEmailRulesUpdate(input: $input) {
        ...InboundEmailRulesFragment
    }
}
